

import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const IssuingEntitySecondaryMasterUDIDI = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "IssuingEntitySecondaryMaster_UDI_DI";
	const fieldTitle = "Issuing Entity Secondary UDI-DI Code / (Master) UDI-DI";
	const LOV = [

		{ key: "", value: "" },
		{ key: "GS1", value: "GS1" },
        { key: "HIBCC", value: "HIBCC" },
        { key: "ICCBBA", value: "ICCBBA" },
        { key: "IFA", value: "IFA" },
        { key: "EUDAMED", value: "EUDAMED" },

	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default IssuingEntitySecondaryMasterUDIDI;


